"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimeRemaining = void 0;

var _luxon = require("luxon");

var _react = _interopRequireDefault(require("react"));

var _useCurrentTime = require("../../utils/useCurrentTime");

var _Flex = require("../Flex");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function padWithZero(num) {
  return num.toString().padStart(2, "0");
}
/** TimeRemaining */


var TimeRemaining = function TimeRemaining(_ref) {
  var countdownEnd = _ref.countdownEnd,
      currentTime = _ref.currentTime,
      _ref$highlight = _ref.highlight,
      highlight = _ref$highlight === void 0 ? "purple100" : _ref$highlight,
      _ref$labelFontSize = _ref.labelFontSize,
      labelFontSize = _ref$labelFontSize === void 0 ? "3" : _ref$labelFontSize,
      labelWithoutTimeRemaining = _ref.labelWithoutTimeRemaining,
      labelWithTimeRemaining = _ref.labelWithTimeRemaining,
      timeEndedDisplayText = _ref.timeEndedDisplayText,
      _ref$timerFontSize = _ref.timerFontSize,
      timerFontSize = _ref$timerFontSize === void 0 ? "3" : _ref$timerFontSize,
      trailingText = _ref.trailingText;

  var duration = _luxon.Duration.fromISO(_luxon.DateTime.fromISO(countdownEnd).diff((0, _useCurrentTime.useCurrentTime)(currentTime)).toString());

  var hasEnded = Math.floor(duration.seconds) <= 0;
  var days = "".concat(padWithZero(Math.max(0, Math.floor(duration.as("days")))), "d ");
  var hours = "".concat(padWithZero(Math.max(0, Math.floor(duration.as("hours") % 24))), "h ");
  var minutes = "".concat(padWithZero(Math.max(0, Math.floor(duration.as("minutes") % 60))), "m ");
  var seconds = "".concat(padWithZero(Math.max(0, Math.floor(duration.as("seconds") % 60))), "s");
  return /*#__PURE__*/_react.default.createElement(_Flex.Flex, {
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: timerFontSize,
    color: highlight,
    weight: "medium"
  }, hasEnded && timeEndedDisplayText ? timeEndedDisplayText : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, days, hours, minutes, seconds, trailingText && " ".concat(trailingText))), (labelWithTimeRemaining || labelWithoutTimeRemaining) && /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
    size: labelFontSize,
    weight: "medium"
  }, hasEnded ? labelWithoutTimeRemaining : labelWithTimeRemaining));
};

exports.TimeRemaining = TimeRemaining;
TimeRemaining.displayName = "TimeRemaining";
//# sourceMappingURL=TimeRemaining.js.map